import {addNamespace} from '#/notes/store/helpers'

export const actionTypes = {
  FETCH_NOTES: 'fetchNotes',
  FETCH_NOTE_BY_ID: 'fetchNoteById',
  FETCH_SORTABLE_NOTES: 'fetchSortableNotes',
  UPDATE_USER_FILTERS: 'updateUserFilters',
  DELETE_NOTE: 'deleteNote',
  ADD_NOTE: 'addNote',
  REFRESH_NOTES: 'refreshNotes',
  FETCH_NOTE_HISTORY: 'fetchNoteHistory',
  SWITCH_TO_MODE: 'switchToMode',
  FETCH_NOTE_TAGS: 'fetchNoteTags',
  FETCH_ALL_NOTE_TAGS: 'fetchAllNoteTags',
  ADD_NOTE_TAG: 'addNoteTag',
  UPDATE_NOTE_TAG: 'updateNoteTag',
  FETCH_NOTE_TYPES: 'fetchNoteTypes',
  FETCH_ALL_NOTE_TYPES: 'fetchAllNoteTypes',
  ADD_NOTE_TYPE: 'addNoteType',
  UPDATE_NOTE_TYPE: 'updateNoteType',
  FETCH_ALL_DOMAINS: 'fetchAllDomains'
}

export default addNamespace('notes/', actionTypes)
